<template>
  <ul class="nav navbar-nav nav-mobile-menu">
    <h5 id="fullname"><span class="ti-user"></span>{{ fullname }}</h5>
    <slot></slot>
  </ul>
</template>
<script>
export default {

  data() {
    return {
      fullname: '',
    };
  },
  created(){
    this.fullname = localStorage.getItem('fullname');
  }
};
</script>
<style>
#fullname{text-align: left; color: #fff;}
#fullname span{display: inline-block; margin-left: 7px; margin-right: 10px;}
</style>
